<div>
    <app-reservations-mesas [payment]="payment"></app-reservations-mesas>
</div>